import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=20027ac7&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=20027ac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20027ac7",
  null
  
)

export default component.exports